import { render, staticRenderFns } from "./BaseInputLabel.vue?vue&type=template&id=44a001a6"
import script from "./BaseInputLabel.vue?vue&type=script&lang=js"
export * from "./BaseInputLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports